import * as React from 'react';
import { AboutSdelkaLayout } from '../../../components/AboutSdelka';
import { ABOUT_SDELKA_ITEMS, getAboutSdelkaHeading } from './constants';
import { AboutSdelkaItem } from '../../../components/AboutSdelka/AboutSdelkaItem';
import { useApplicationContext } from '../../../utils/applicationContext';

export const AboutSdelka: React.FC = () => {
  const {
    custom: { pageType },
  } = useApplicationContext();
  const heading = getAboutSdelkaHeading(pageType);

  return (
    <AboutSdelkaLayout {...heading}>
      {ABOUT_SDELKA_ITEMS.map((item, index) => (
        <AboutSdelkaItem key={item.title + index} {...item} />
      ))}
    </AboutSdelkaLayout>
  );
};
